import React, { Component } from "react";
import Button from "@material-ui/core/Button";
import styled from "styled-components";

import { withFormik, Form, Field } from "formik";
import * as Yup from "yup";

import ActionFormButton from "../../../common/ActionFormButton";
import ChangePassword from "./components/ChangePassword";

import {
  handleRepeatedFormValues,
  renderRowWithTwoItems,
  renderSectionTitle,
  getRowItemObject,
  Section,
  Wrapper,
  renderRowWithSingleItem,
} from "../../../common/FormUtils";

import ImageUpload from "../../../common/ImageUpload";
import { Quote } from "../../../../types/Quote";

const EditPasswordButtonWrapper = styled.div`
  display: block;
`;

type Props = {
  setFieldValue: Function;
  onChageFormToEditMode: Function;
  onEditPassword: Function;
  handleSubmit: Function;

  onRemoveItem: Function;
  isSubmitting: boolean;
  item: any;
  mode: string;
  errors: any;
  values: any;
};

type State = {
  isPasswordDialogOpen: boolean;
};

class QuoteForm extends Component<Props, State> {
  state = {
    isPasswordDialogOpen: false,
  };

  onTogglePassowordDialog = (): void => {
    const { isPasswordDialogOpen } = this.state;

    this.setState({
      isPasswordDialogOpen: !isPasswordDialogOpen,
    });
  };

  onChangePassword = (newPassword: string): void => {
    const { onEditPassword } = this.props;

    this.setState(
      {
        isPasswordDialogOpen: false,
      },
      () => onEditPassword(newPassword)
    );
  };

  renderImageSection = (): any => (
    <Section>
      {renderSectionTitle("Photo")}
      {this.renderImageField()}
    </Section>
  );

  renderImageField = () => {
    const imageInputFieldData = getRowItemObject(
      "",
      "Selecciona una imagen para mostrar",
      "file",
      "imageURL"
    );

    return (
      <Field name="imageURL">
        {({ field, form }) => (
          <ImageUpload
            field={field}
            form={form}
            actionId={this.props.values?.id}
            reference={"Author"}
          />
        )}
      </Field>
    );
  };
  renderUserInfoSection = () => {
    const nameInputFieldData = getRowItemObject(
      "Quote",
      "Type the quote",
      "textarea",
      "quote"
    );
    const tagsInputFieldData = getRowItemObject(
      "Author",
      "Type the author name...",
      "text",
      "authorName"
    );

    const sourceInputFieldData = getRowItemObject(
      "Source",
      "Type the source...",
      "text",
      "source"
    );

    return (
      <Section>
        {renderRowWithTwoItems(
          nameInputFieldData,
          tagsInputFieldData,
          this.props
        )}
        {renderRowWithSingleItem(sourceInputFieldData, this.props)}
      </Section>
    );
  };

  render() {
    const {
      onChageFormToEditMode,
      onRemoveItem,
      handleSubmit,
      isSubmitting,
      item,
      mode,
    } = this.props;

    const { isPasswordDialogOpen } = this.state;

    return (
      <Wrapper>
        <Form>
          {this.renderUserInfoSection()}
          {this.renderImageSection()}
          <ActionFormButton
            onChageFormToEditMode={onChageFormToEditMode}
            onClick={this.props.handleSubmit}
            onRemoveItem={onRemoveItem}
            disabled={isSubmitting}
            entity="Author"
            canBeRemoved
            mode={mode}
          ></ActionFormButton>
        </Form>
      </Wrapper>
    );
  }
}

const getPasswordValidation = (mode: string): Object => {
  if (mode === "create") {
    return {};
  }

  return {};
};

const CustomForm = withFormik({
  mapPropsToValues: ({
    item,
  }: {
    item: Quote;
    onCreateItem;
    onEditItem;
    mode;
  }) => ({
    stepID: item.stepID || "",
    quote: item.quote || "",
    planID: item.planID || "",
    id: item?.id || "",
    likeCount: item.likeCount || "",
    imageURL: item.imageURL || "",
    source: item.source || "",
    authorName: item.authorName || "",
    communityId: item?.communityId || "",
  }),

  validationSchema: ({ item, usernames, mode }) =>
    Yup.lazy(() => Yup.object().shape({})),

  handleSubmit(values, { setSubmitting, props }) {
    const { onCreateItem, onEditItem, mode } = props;

    const properCallback = mode === "edit" ? onEditItem : onCreateItem;

    properCallback({
      ...values,
    });

    setSubmitting(false);
  },

  //@ts-ignore
})(QuoteForm);

export default CustomForm;
